<template>
    <div :class="[
        'samplingbox',
        { 'is-any-sample-selected': isAnySampleSelected },
        { 'is-disabled': isDisabled }
    ]">
        <div class="wrapper">
            <header class="samplingbox-header text-center">
                <div
                    v-bastards
                    v-html="headerHtml"
                />
                <div
                    v-bastards
                    class="samplingbox-header-custom-pdf fs-16 fs-lh-20"
                    v-html="benefitsHtml"
                />
            </header>
            <div
                v-for="flag in flags"
                :key="flag"
                class="samplingbox-flag text-center"

            >
                <span
                    v-bastards
                    v-text="flag"
                />
            </div>

            <div class="grid grid-3">
                <div
                    v-for="(sample, i) in samples"
                    :key="sample.id"
                    :class="[
                        'samplingbox-sample',
                        { 'is-checked': selectedSamples[i] },
                        { 'is-faded': !selectedSamples[i] && isAnySampleSelected }
                    ]"
                >
                    <div
                        class="flex flex-space-50"
                        @click="onClickSample(i, sample.id)"
                    >
                        <div class="samplingbox-sample-image">
                            <ImageLazy
                                :image-url="sample.image.imageUrl"
                                :height="sample.image.height"
                                :alt="sample.name"
                            />
                            <div class="samplingbox-sample-footer">
                                <CheckboxLarge
                                    v-model="selectedSamples[i]"
                                    :name="`sample-${i}`"
                                />
                            </div>
                        </div>
                        <div
                            v-bastards
                            class="samplingbox-sample-body"
                            v-html="sample.bodyHtml"
                        />
                    </div>
                </div>
            </div>
            <slot />
            <footer
                v-if="footerHtml"
                v-html="footerHtml"
                class="samplingbox-footer"
            />
        </div>
    </div>
</template>

<script>
import CheckboxLarge from '@/components/form/CheckboxLarge'

export default {
    components: {
        CheckboxLarge
    },

    props: {
        headerHtml: {
            type: String,
            required: false,
            default: ''
        },
        benefitsHtml: {
            type: String,
            required: false,
            default: ''
        },
        footerHtml: {
            type: String,
            required: false,
            default: ''
        },
        flags: {
            type: Array,
            required: false,
            default: () => []
        },
        samples: {
            type: Array,
            required: true,
            validator: value => value.length === 2
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            selectedSamples: [
                false,
                false,
                false
            ]
        }
    },

    computed: {
        isAnySampleSelected() {
            return this.selectedSamples.filter(value => value).length > 0
        }
    },

    created() {
        this.selectedSamples = new Array(this.samples.length).fill(false)
    },

    watch: {
        selectedSamples: {
            handler: function(newSnapshot/*, oldSnapshot*/) {
                for (let i = 0; i < newSnapshot.length; i++) {
                    this.$nextTick(() => {
                        // this.selectedSamples[i] = false
                    })
                }
            },
            immediate: true
        },

        isAnySampleSelected(snapshot) {
            this.$emit('changeAnySelected', snapshot)
        }
    },

    methods: {
        onClickSample(index, sampleId) {
            let snapshot = []

            for (let i = 0; i < this.selectedSamples.length; i++) {
                if (i === index) {
                    snapshot.push(true)
                }
                else {
                    snapshot.push(false)
                }
            }

            this.selectedSamples = snapshot

            this.$emit('changeSample', sampleId)
        }
    }
}
</script>

<style lang="scss">
.samplingbox {
    background-color: $color-bg;
    position: relative;
    padding: 35px 0 0;

    &:after {
        content: '';
        @include hide();
        @include size(0);
        @include transform(translateY(-15px));
        @include transition(.150s);
        border-left: 30px solid transparent;
        border-right: 30px solid transparent;
        border-top: 30px solid $color-bg;
        position: absolute;
        left: calc(50% - 21px);
        bottom: -30px;
    }

    &.is-any-sample-selected {
        &:after {
            @include show();
            @include transform-none();
        }
    }

    &.is-disabled {
        .samplingbox-sample {
            &.is-faded {
                &:nth-child(2n - 1) {
                    @include transform(translateX(50%));
                }

                &:nth-child(2n) {
                    @include transform(translateX(-50%));
                }

                opacity: 0;
            }

            &.is-checked {
                &:nth-child(2n - 1) {
                    @include transform(translateX(50%));
                }

                &:nth-child(2n) {
                    @include transform(translateX(-50%));
                }
            }
        }
    }

    &-header {
        letter-spacing: -1px;
        padding: 37px 115px 40px;

        h1, h2, h3, h4, h5, h6 {
            margin-bottom: 8px;
            margin-top: -8px;
        }

        mark {
            font-weight: $font-weight-bold;
            background-color: transparent;
            position: relative;
            z-index: 1;

            &:before {
                content: '';
                @include position-cover();
                background-color: $color-secondary;
                top: 7px;
                left: -2px;
                right: -2px;
                z-index: -1;
            }
        }

        &-custom {
            &-1 {
                margin-left: auto;
                margin-right: auto;
                text-align: right;
                padding-top: 16px;
                padding-left: 20px;
                padding-right: 20px;
                max-width: 1030px;
            }

            &-2 {
                margin-left: auto;
                margin-right: auto;
                padding-top: 16px;
                padding-left: 20px;
                padding-right: 20px;
                max-width: 1030px;
            }

            &-3 {
                margin-left: auto;
                margin-right: auto;
                padding-top: 18px;
                padding-left: 20px;
                padding-right: 20px;
                max-width: 1030px;
            }

            &-pdf {
                strong {
                    font-weight: $font-weight-bold;
                }
            }
        }
    }

    &-footer {
        padding: 0 15px 35px;
    }

    &-flag {
        display: block;

        > span {
            display: inline-block;
        }
    }

    &-sample {
        @include transition(.250s);
        cursor: pointer;
        text-align: center;
        margin: 0 auto 50px;
        max-width: 565px;

        > .flex {
            display: block;
            position: relative;

            &:after {
                content: '';
                @include position-cover();
            }
        }

        &:nth-child(2n - 1) {
            > .flex {
                flex-direction: row-reverse;
            }

            .samplingbox-sample-body {
                ul {
                    > li {
                        display: block;
                        // float: right;
                        clear: right;
                        // white-space: nowrap;
                    }
                }
            }
        }

        &-body {
            text-align: left;
            padding: 15px 0 0;

            @media (min-width: $screen-laptop + 1px) {
                width: 310px;
            }

            @media (min-width: $screen-laptop + 1px) and (max-width: 1100px) {
                width: 260px;
            }

            ul {
                list-style-type: none;

                > li {
                    position: relative;
                    font-size: 1.4rem;
                    line-height: 1.7rem;

                    &:before {
                        content: '';
                        @include size(6px);
                        background-color: $color-default;
                        position: absolute;
                        left: -12px;
                        top: 7px;
                    }
                }
            }
        }

        &-image {
            > .image-lazy {
                img {
                    @include transform(scale(1));
                }
            }
        }

        &-body,
        &-image > .image-lazy {
            @include transition(.150s);
        }

        &-footer {
            text-align: center;
            padding: 36px 0 17px;
        }

        &.is-faded & {
            &-body,
            &-image > .image-lazy {
                opacity: .36;
            }
        }

        &:hover & {
            &-footer {
                .checkbox-large {
                    &-label {
                        &:before {
                            @include transform-none();
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: $screen-page) {
        .grid-space-90 {
            grid-column-gap: 40px;
            grid-row-gap: 40px;
        }

        &-sample {
            &:nth-child(2n - 1) & {
                &-body {
                    padding-right: 25px;
                }
            }

            &:nth-child(2n) & {
                &-body {
                    padding-left: 25px;
                }
            }
        }
    }

    @media (max-width: $screen-laptop) {
        .grid {
            display: block;
        }

        &-header {
            &-custom {
                &-1,
                &-2 {
                    text-align: center;
                }
            }
        }

        &-sample {
            max-width: 565px;
            margin: 0 auto;
            padding: 0 0 60px;

            &-body {
                padding-top: 0;
            }

            .is-disabled & {
                &.is-checked {
                    transform: none !important;
                    -webkit-transform: none !important;
                }

                &.is-faded {
                    transform: none !important;
                    -webkit-transform: none !important;
                    height: 0;
                }
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        padding: 35px 0 0;

        &-header {
            padding-top: 20px;
            padding-left: 20px;
            padding-right: 20px;

            h1, h2, h3, h4, h5, h6 {
                line-height: 55px;
                padding-top: 35px;
                padding-bottom: 10px;
                font-size: 4.9rem;
            }
        }

        &-sample {
            &:nth-child(2n - 1),
            &:nth-child(2n) {
                text-align: center;

                .samplingbox-sample-body {
                    padding-left: 25px;
                    padding-right: 25px;

                    ul {
                        > li {
                            text-align: left;
                            float: none;
                            white-space: normal;
                        }
                    }
                }
            }

            > .flex {
                display: block;
            }
        }
    }
}
</style>
